<mat-card appearance="outlined" class="correct-report-card">
  <form [formGroup]="competitionCardForm">
    <mat-card-title style="text-align: center;">
      {{'Competition management' | translate}}
    </mat-card-title>
    <mat-card-subtitle>
      <div style="text-align: center">
        <mat-form-field appearance="fill">
          <mat-label>{{'Competition name' | translate}}</mat-label>
          <input matInput placeholder="{{'Competition name' | translate}}" formControlName="competitionName" required>
          <mat-error *ngIf="this.competitionCardForm.get('competitionName').invalid">{{getErrorMessage(this.competitionCardForm.get('competitionName')) | translate}}</mat-error>
        </mat-form-field>
      </div>
    </mat-card-subtitle>
    <mat-card-content>
      <h2>{{'Dates management' | translate}}</h2>
      <div class="competition-and-registration-div">
        <cec-date-time-picker></cec-date-time-picker>
        <mat-error *ngIf="this.competitionCardForm.get('registrationEnabledFrom').invalid || this.competitionCardForm.get('registrationEnabledTo').invalid">{{getErrorMessageRangeDatePicker() | translate}}</mat-error>
        <mat-form-field appearance="fill">
          <mat-label>{{'Date range for competition' | translate}}</mat-label>
          <mat-date-range-input [rangePicker]="picker" required>
            <input matStartDate placeholder="Start date" formControlName="competitionStart">
            <input matEndDate placeholder="End date" formControlName="competitionEnd">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="this.competitionCardForm.get('competitionStart').invalid || this.competitionCardForm.get('competitionEnd').invalid">{{getErrorMessageRangeDatePicker() | translate}}</mat-error>
        </mat-form-field>
      </div>
      <cec-date-time-picker></cec-date-time-picker>
      <mat-error *ngIf="this.competitionCardForm.get('registrationEnabledFrom').invalid || this.competitionCardForm.get('registrationEnabledTo').invalid">{{getErrorMessageRangeDatePicker() | translate}}</mat-error>
  <!--    <mat-divider inset></mat-divider>-->
  <!--    <h3><b>Attachment management</b></h3>-->
      <h2>{{'Stage management' | translate}}</h2>
      <button mat-button color="primary" (click)="onOpenNewRoundDialog()">
        {{'Add round' | translate}}
      </button>
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngFor="let round of rounds">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{round.name}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-selection-list [multiple]="false">
            <mat-list-option *ngFor="let stage of round.stages; let i = index">
              <div class="stage-list-item">
                {{stage.stageName}}
                <div>
                  <button mat-icon-button matTooltip="{{'Edit stage' | translate}}" aria-label="Example icon button with a vertical three dot icon" (click)="onEditStage(round, stage)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'Delete stage' | translate}}" aria-label="Example icon button with a vertical three dot icon" (click)="onDeleteStage(round, stage)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </mat-list-option>
          </mat-selection-list>
          <mat-action-row>
            <button mat-button color="primary">
              {{'Round results' | translate}}
            </button>
            <button mat-button color="primary" (click)="onCreateStage(round)">
              {{'Add stage' | translate}}
            </button>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
      <h2>{{'Organizers' | translate}}</h2>
      <mat-form-field appearance="fill" style="margin-top: 2%">
        <mat-label>{{'Organizer' | translate}}</mat-label>
        <mat-select formControlName="author"
                    [compareWith]="compareCompetitors">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let competitor of authorsFullData"
                      [value]="competitor">
            {{competitor.firstName + ' ' + competitor.lastName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button color="primary"
              style="margin-left: 8px;"
              [disabled]="authorsFieldIsEmpty()"
              (click)="processAuthors()">
        {{'Add organizer' | translate}}
      </button>
      <mat-list role="list">
        <mat-list-item role="listitem"
                       *ngFor="let competitor of activeAuthors">
          {{competitor.firstName + ' ' + competitor.lastName}}
          <button mat-icon-button
                  [disabled]="this.activeAuthors.length === 1"
                  (click)="deleteActiveAuthor(competitor)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </form>
  <mat-dialog-actions style="display: flex; justify-content: end; margin-top: 5%">
    <button mat-button mat-dialog-close (click)="onCancel()">{{'Cancel' | translate}}</button>
    <button mat-button [disabled]="competitionCardForm.invalid" (click)="onSaveCompetition()">{{'Save competition' | translate}}</button>
  </mat-dialog-actions>
</mat-card>
